import _toConsumableArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React from 'react';
import moment from 'moment';
import { DefaultSeo, NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import OpportunityJsonLd from '@atoms/JsonLd/OpportunityJsonLd';
import { getUrlFromRoute } from '@app/helpers';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function OpportunitySeo(_ref) {
  var opportunity = _ref.opportunity,
    isApply = _ref.isApply;
  var router = useRouter();
  var title = isApply ? opportunity.title : "Apply to - ".concat(opportunity.title);
  var description = opportunity.summary || opportunity.description && opportunity.description.slice(0, 200);
  var opportunityUrl = getUrlFromRoute('view_opportunity', {
    params: {
      slug: opportunity.slug
    },
    locale: router.locale
  });
  var applyUrl = getUrlFromRoute('form_viewer', {
    params: {
      slug: opportunity.slug
    },
    locale: router.locale
  });
  var mediaList = opportunity.gallery ? opportunity.gallery.map(function (image) {
    return {
      url: image.path
    };
  }) : [];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DefaultSeo, {
      title: title,
      locale: true,
      description: description,
      openGraph: {
        url: isApply ? applyUrl : opportunityUrl,
        title: title,
        description: description,
        images: [{
          url: opportunity.logo.path,
          width: 800,
          height: 600,
          alt: "Cover - ".concat(title)
        }].concat(_toConsumableArray(mediaList)),
        site_name: 'Mubazar'
      }
    }), opportunity.start_date && /*#__PURE__*/_jsx(OpportunityJsonLd, {
      url: opportunityUrl,
      title: opportunity.title,
      description: description,
      images: [opportunity.logo.path].concat(_toConsumableArray(mediaList.map(function (_ref2) {
        var url = _ref2.url;
        return url;
      }))),
      location: !opportunity.is_virtual && opportunity.location ? opportunity.location : null,
      startDate: moment(opportunity.start_date),
      offerUrl: applyUrl,
      paymentInfo: opportunity.is_paid ? opportunity.payment_details : null,
      endDate: moment(opportunity.end_date),
      createDate: moment(opportunity.created_at),
      organisation: opportunity.organisation
    })]
  });
}
OpportunitySeo.defaultProps = {
  isApply: false
};
export default OpportunitySeo;